<label
  class="block text-xs font-semibold text-[#25282D] mb-1"
>
  {{ label }}
  @if (showAsterisk) {
    <span class="text-orange-500 text-xs font-semibold">*</span>
  }
</label>

<div class="relative w-full">
  <div class="relative">
    <input
      #timeInput
      type="text"
      [placeholder]="placeholder"
      [disabled]="disabled"
      [readonly]="true"
      [value]="displayValue"
      (click)="openTimepicker()"
      [ngClass]="{
        'border-red-500 focus:!border-red-500 focus:ring-red-500': showError && (errorMessage || internalErrorMessage),
        'bg-[#E7E7EF] select-text pointer-events-none': disabled,
        'bg-[#F8F8FE] cursor-pointer': !disabled
      }"
      class="w-full text-[#25282D] text-[12px] px-2 py-[7px] pr-8 border border-[#DBE0E6] focus:outline-none focus:!border-[#C7B1FF] focus:ring-[#C7B1FF] rounded-[5px] placeholder:text-[12px] placeholder-[#96A0B5] focus:shadow focus:shadow-[#F0F0F0]"
    />
    
    <!-- Clock Icon -->
    <button
      type="button"
      [disabled]="disabled"
      (click)="openTimepicker(); $event.stopPropagation()"
      class="absolute right-2 top-1/2 -translate-y-1/2 flex items-center justify-center text-[#96A0B5] hover:text-[#6729FF] transition-colors cursor-pointer disabled:cursor-not-allowed disabled:opacity-50 bg-transparent border-0 p-0 z-10"
      aria-label="Open time picker"
      tabindex="-1"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="10"></circle>
        <polyline points="12 6 12 12 16 14"></polyline>
      </svg>
    </button>
  </div>

  <!-- Error Message -->
  @if (showError && (errorMessage || internalErrorMessage)) {
    <div class="mt-1 text-xs text-red-500">
      {{ errorMessage || internalErrorMessage }}
    </div>
  }
</div>
